import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

// import BrandDetection from './BrandDetection.vue'
import BrandDetectionReport from './BrandDetectionReport.vue'
// import reportSummary from '../pdf/report-summary-2';
import pdf from '../pdf';
import AppHeader from '../../components/layout/Header'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/detection/:projectId',
      name: 'project',
      components: {
        default: BrandDetectionReport,
        header: AppHeader
      },
      meta: {
        dontShowInMenu: true,
        highlightProject: true,
      },
      beforeEnter: allowOnlyAuthorized()
    },
    {
      path: '/detection/:projectId/pdf',
      name: 'project',
      components: {
        default: pdf,
        header: AppHeader
      },
      meta: {
        dontShowInMenu: true,
        highlightProject: true,
      },
      beforeEnter: allowOnlyAuthorized()
    },
  ])
}
